import { FC } from 'react';

import Icon from './image.svg';

export const WalletConnectLabel: FC = () => <img src={Icon} alt="wallet-connect logo" />;
